// ─── 🎟️ Quanto valgono i Crediti: una regola sola ──────────────────────────
//
// Voce 36, mockup approvato il 27/09/2026 (strada A): 🗣️ *«approvato, nome
// consigliato e strada A»*. Fino a quel giorno i Crediti avevano due scadenze,
// una nell'acconto (`mesiCredito`) e una nel premio (`mesiScadenza`): per il
// socio sono la stessa cosa, e adesso la regola è una. La legge il premio
// quando li dà (🔄 30/09/2026: l'acconto, che la leggeva anche lui, non c'è più).
//
// ⚖️ Cambiarla vale per i Crediti che nascono da quel momento: la scadenza si
// scrive su ogni Credito quando nasce, e quelli già dati la tengono.
import { z } from 'zod';
export const impostazioniCreditiSchema = z.object({
    /** Quanti mesi vale un Credito, da quando nasce. */
    mesi: z.number().int().min(1).max(60),
    /** Quanti giorni prima della scadenza il bot avvisa il socio. */
    giorniAvviso: z.number().int().min(1).max(120),
});
/** 🗣️ *«facciamo durare i crediti nel borsellino sei mesi»* (27/09/2026). */
export const IMPOSTAZIONI_CREDITI_DI_PARTENZA = { mesi: 6, giorniAvviso: 30 };
//# sourceMappingURL=crediti.js.map